// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.list-lite.hover #item-two-line:hover {
  background: #f5f5f5;
  font-weight: 700;
}
.list-lite.hover #item-one-line:hover {
  background: #f5f5f5;
  font-weight: 700;
}
.list-lite {
  font-size: 14px;
}
.list-lite #item-two-line {
  position: relative;
  width: 100%;
  display: inline-block;
}
.list-lite #item-first-line {
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.list-lite #item-one-line {
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
}
.list-lite #item-primary {
  display: inline-block;
}
.list-lite #item-secondary {
  font-size: 90%;
  opacity: 0.7;
}
.list-lite #item-right {
  position: relative;
  top: 0;
  right: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.list-lite #item-right button {
  padding: 0 !important;
}
.list-lite #item-left {
  align-items: center;
  justify-content: flex-start;
  display: flex;
}
.list-lite #item-bottom {
  display: inline-block;
  padding-right: 16px;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
